import React, { useState } from 'react';
import './SharePage.css';

const SharePage = ({ path, title, description }) => {
    const [copied, setCopied] = useState(false);
    
    const baseUrl = 'https://makeeasyway.in';
    const urlToShare = `${baseUrl}${path}`;
    
    const encodedUrl = encodeURIComponent(urlToShare);
    const encodedTitle = encodeURIComponent(title);
    const encodedDesc = encodeURIComponent(description);

    const shareLinks = {
        whatsapp: `https://api.whatsapp.com/send?text=${encodedTitle}%20-%20${encodedDesc}%20${encodedUrl}`,
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
        twitter: `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`,
        linkedin: `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}&title=${encodedTitle}&summary=${encodedDesc}`,
        telegram: `https://t.me/share/url?url=${encodedUrl}&text=${encodedTitle}`
    };

    const handleCopy = () => {
        navigator.clipboard.writeText(urlToShare);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000); // Reset after 2 seconds
    };

    return (
        <div className="mew-share-card">
            <div className="mew-share-header">
                <h2>Share this tool</h2>
                <p>Help others discover useful tools on makeeasyway.in!</p>
            </div>

            <div className="mew-social-grid">
                <a href={shareLinks.whatsapp} target="_blank" rel="noopener noreferrer" className="mew-btn mew-whatsapp">
                    WhatsApp
                </a>
                <a href={shareLinks.facebook} target="_blank" rel="noopener noreferrer" className="mew-btn mew-facebook">
                    Facebook
                </a>
                <a href={shareLinks.twitter} target="_blank" rel="noopener noreferrer" className="mew-btn mew-twitter">
                    Twitter
                </a>
                <a href={shareLinks.telegram} target="_blank" rel="noopener noreferrer" className="mew-btn mew-telegram">
                    Telegram
                </a>
            </div>

            <div className="mew-copy-section">
                <input 
                    type="text" 
                    value={urlToShare} 
                    readOnly 
                    className="mew-url-input"
                />
                <button 
                    onClick={handleCopy} 
                    className={`mew-copy-btn ${copied ? 'copied' : ''}`}
                >
                    {copied ? 'Copied!' : 'Copy Link'}
                </button>
            </div>
        </div>
    );
};

export default SharePage;